<template>
  <div class="user_show">
    <span>{{ $t('meta_title.user.show') }}</span>

    <div v-if="user">
      <p><strong>{{user.firstname}} {{user.lastname}}</strong></p>
      <p>{{user.email}}</p>
      <p>{{user.role}}</p>
    </div>

    <router-link-guard :to="{ name: 'UserAuthorization', params: { id: user.id }}" :msg_slug="'object.user.authorizations'" :authorization="'user-rights_edit'"/>
    <router-link-guard :to="{ name: 'UserEdit', params: { id: user.id }}" :msg_slug="'action.edit'" :authorization="'user_edit'"/>
    <router-link-guard :to="{ name: 'UserDelete', params: { id: user.id }}" :msg_slug="'action.archive.delete'" :authorization="'user_archive'"/>
  </div>
</template>

<script>

  export default {
    name: 'UserShow',
    data() {
      return {
        user: [],
      }
    },
    created() {
      this.user.id = this.$route.params.id;
      this.$http.get(`user/` + this.$route.params.id)
        .then(response => {
          this.user      = response.data
          this.user.role = this.user.roles[0];
        })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/show.vue